import { navigate } from '../ui/router.ts'
import { isCapacitorNative } from '../api/ZionServer.ts'
import { isNativePushPlatform } from '../push/nativePush.ts'

/**
 * Pair request: su Capacitor il banner+suono arrivano via APNs.
 * Qui solo fallback Notification Web (PWA) + navigazione.
 */
export async function notifyPairingRequest(nickname: string): Promise<void> {
  try {
    if (isCapacitorNative() || isNativePushPlatform()) return
  } catch {
    /* continue web path */
  }
  if (!('Notification' in window) || Notification.permission !== 'granted') return
  try {
    const label = nickname.trim() || 'Un contatto'
    const n = new Notification('ZION — Richiesta contatto', {
      body: `${label} vuole chattare`,
      icon: '/app/icons/icon-192.png',
      tag: 'zion-pair-request',
      silent: false,
    })
    n.onclick = () => {
      window.focus()
      navigate('home')
      n.close()
    }
  } catch {
    /* ignore */
  }
}
